const setFixedHeader = () => {
  const header = document.querySelector('#site-admissions-header');
  if (!header) return false;

  const setHeaderStatus = () => {
    header.classList.toggle('is-fixed', window.scrollY > 0)
  }

  setHeaderStatus();

  window.addEventListener('scroll', () => {
    setHeaderStatus();
  })
}

export default setFixedHeader;